import { useState } from 'react';

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpValue = (formData.get('phone_alt') as string || '').trim();
    if (hpValue) {
      setStatus('success');
      setStatusMessage('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    setStatus('loading');
    setStatusMessage('');

    try {
      const submitAddr = 'http://aduvet.com/';
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries()).filter(([key]) => key !== 'phone_alt').map(([k, v]) => [k, v.toString()])
        ).toString(),
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const code: string | undefined = (() => {
        if (parsed && typeof (parsed as Record<string, unknown>).code === 'string') {
          return (parsed as Record<string, unknown>).code as string;
        }
        return undefined;
      })();

      const serverMsg: string = (() => {
        if (parsed) {
          const meta = (parsed as Record<string, unknown>).meta as Record<string, unknown> | undefined;
          if (meta && typeof meta.message === 'string') return meta.message;
          if (typeof (parsed as Record<string, unknown>).message === 'string') return (parsed as Record<string, unknown>).message as string;
        }
        return responseText;
      })();

      if (res.ok && code === 'OK') {
        setStatus('success');
        setStatusMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        setStatus('error');
        setStatusMessage(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setStatusMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" noValidate>
      <div>
        <label htmlFor="contact-name" className="block text-foreground-700 text-sm font-medium mb-1.5">
          姓名
        </label>
        <input
          type="text"
          id="contact-name"
          name="name"
          required
          className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
          placeholder="请输入您的姓名"
        />
      </div>

      <div>
        <label htmlFor="contact-email" className="block text-foreground-700 text-sm font-medium mb-1.5">
          邮箱
        </label>
        <input
          type="email"
          id="contact-email"
          name="email"
          required
          className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
          placeholder="请输入您的邮箱"
        />
      </div>

      <div>
        <label htmlFor="contact-subject" className="block text-foreground-700 text-sm font-medium mb-1.5">
          主题
        </label>
        <input
          type="text"
          id="contact-subject"
          name="subject"
          required
          className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
          placeholder="请输入留言主题"
        />
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-foreground-700 text-sm font-medium mb-1.5">
          留言内容
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          className="w-full px-4 py-2.5 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
          placeholder="请输入您的留言内容（500字以内）"
        ></textarea>
      </div>

      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-hp"
      />

      <button
        type="submit"
        disabled={status === 'loading'}
        className="w-full px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm whitespace-nowrap cursor-pointer"
      >
        {status === 'loading' ? (
          <span className="flex items-center justify-center gap-2">
            <i className="ri-loader-4-line animate-spin"></i>
            提交中...
          </span>
        ) : (
          '发送留言'
        )}
      </button>

      {status === 'success' && (
        <div className="p-3 bg-accent-100 text-accent-700 rounded-lg text-sm flex items-center gap-2">
          <i className="ri-checkbox-circle-fill"></i>
          {statusMessage}
        </div>
      )}

      {status === 'error' && (
        <div className="p-3 bg-red-50 text-red-600 rounded-lg text-sm flex items-center gap-2">
          <i className="ri-error-warning-fill"></i>
          {statusMessage}
        </div>
      )}
    </form>
  );
}